/**
 * Default renderer impls — IllustrationRenderer, VideoRenderer,
 * LazyGLBRenderer. Pre-registered into a registry by
 * buildDefaultRegistry().
 *
 * GLBRenderer is intentionally NOT re-exported here: a static export
 * would pull three.js into every consumer bundle. The registry uses
 * LazyGLBRenderer (dynamic import → separate async chunk); direct
 * access goes through the package subpath
 * `@arkturian/audio-guide/knowledge/renderers/GLBRenderer`.
 */
export { IllustrationRenderer } from './IllustrationRenderer';
export { VideoRenderer } from './VideoRenderer';
export { LazyGLBRenderer } from './LazyGLBRenderer';
import { KnowledgeRendererRegistry } from '../renderer';
import { IllustrationRenderer } from './IllustrationRenderer';
import { VideoRenderer } from './VideoRenderer';
import { LazyGLBRenderer } from './LazyGLBRenderer';
/** Build a registry pre-populated with library default renderers.
 *  Skin can register its own renderers BEFORE calling this if they
 *  want to override defaults (first-match wins in resolve). */
export function buildDefaultRegistry() {
    const reg = new KnowledgeRendererRegistry();
    reg.register(new IllustrationRenderer());
    reg.register(new VideoRenderer());
    reg.register(new LazyGLBRenderer());
    return reg;
}
//# sourceMappingURL=index.js.map